define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"csi/xml"
], function(declare,Copy,xml) {

	return declare(Copy, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for request level
			view.defView.removeField("OrdersByColor")
			this.inherited(arguments);
		},
		
		_toWriterSource: function() {
			// summary: add destination season and collection parameters to CopyNode operation
			var	call = this.inherited(arguments);

			if (this.m_cnCopy) {
				this.m_cnCopy.addParameter("Node Name", xml.ATTR_STRING, this.m_formData.getFieldValue("Node Name", true));
			}

			return call;
		}
	});
});